// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purpelBtn {
  background-color: #2f3293;
  box-shadow: 2px 2px 2px 0px #00000040;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/commanComponents/buttons/purpelBtn.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".purpelBtn {\n  background-color: #2f3293;\n  box-shadow: 2px 2px 2px 0px #00000040;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
